/**
 * Image Utilities
 * Shared functions for loading and working with images
 */

const images = require.context('../assets', false, /\.png$/);

/**
 * Get team logo by team name
 * @param {string} name - Team name
 * @returns {string|undefined} - Logo image path or undefined if not found
 */
export const getLogo = (name) => {
  try {
    return images(`./Team=${name}.png`);
  } catch {
    return undefined;
  }
};
